import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Text } from '@abyss/web/ui/Text';
import find from 'lodash/find';
import pick from 'lodash/pick';
import React, { useCallback, useRef } from 'react';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { mobileOnly } from '../../../../common/ConstantsStyles';
import { useGetRecommendationPreferencesStatus } from '../../../../hooks/useGetRecommendationPreferencesStatus';
import { useLagoon } from '../../../../hooks/useLagoon';
import { StoreKeys } from '../../../../hooks/useStore/state';
import { useStore } from '../../../../hooks/useStore/useStore';

const PREFERENCE_KEYS_TO_COMPARE = [
  'distance',
  'evngApptAvbl',
  'onlineApptSchdlAvbl',
  'providerBoardCertStatus',
  'providerGender',
  'virtualApptAvbl',
  'wkndApptAvbl',
  'languagesSpoken',
];

export const CompareSmartChoiceHeader = ({ handleBackButtonClick }) => {
  const preferenceData = useStore(StoreKeys.RECOMMENDATION_PREFERENCES);
  const setRecommendationPreferences = useStore(
    StoreKeys.SET_RECOMMENDATION_PREFERENCES
  );
  const initialPreferencesRef = useRef(
    pick(preferenceData, PREFERENCE_KEYS_TO_COMPARE)
  );

  const [, getPreferencesStatus] = useGetRecommendationPreferencesStatus({
    handleSuccess: (result) => {
      const freshPreferences = result?.data?.recommendationPreferencesStatus;
      const newValues = pick(freshPreferences, PREFERENCE_KEYS_TO_COMPARE);
      const preferencesChanged = PREFERENCE_KEYS_TO_COMPARE.some(
        (key) => initialPreferencesRef.current[key] !== newValues[key]
      );
      handleBackButtonClick();
      if (preferencesChanged) {
        setRecommendationPreferences(freshPreferences);
        sessionStorage.setItem('COMPARE_RELOAD_FROM_HEADER', 'true');
        globalThis.location.reload();
      }
    },
    handleError: () => {
      handleBackButtonClick();
    },
  });

  const onBackButtonClick = useCallback(() => {
    getPreferencesStatus();
  }, [getPreferencesStatus]);

  const lagoonData = useLagoon('ui-messaging')();
  const mobileScreen = useMediaQuery(mobileOnly);
  const compare_provider = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE_PROVIDERS,
  })?.message;
  const heading = find(lagoonData, {
    key: mobileScreen
      ? ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_SWAP_PROVIDERS_HEADING
      : ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_BACK_TO_RESULTS_HEADING,
  })?.message;
  const button = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_BACK_TO_RESULTS_BUTTON,
  })?.message;

  return (
    <React.Fragment>
      <Heading display="h2" offset={1}>
        {compare_provider}
      </Heading>
      <Text color="$gray7">{heading}</Text>
      <Flex>
        <Button
          css={{ marginTop: '24px' }}
          data-testid="back-button"
          onClick={onBackButtonClick}
        >
          <IconSymbol
            css={{ marginRight: '8px' }}
            icon="arrow_back"
            size="sm"
          />
          {button}
        </Button>
      </Flex>
    </React.Fragment>
  );
};
